<ion-app [class.erdman]="brand === 'erdman'" [class.hop]="brand === 'hop'" [class.inteliforz]="brand === 'inteliforz'">
  <div class="update-banner" role="status" aria-live="polite" [class.visible]="updateAvailable$ | async">
    <ng-container *ngIf="updateAvailable$ | async">
      <span class="update-banner-text">{{ 'SHARED.New_Version_Available' | translate }}</span>
      <button type="button" class="update-banner-reload" (click)="versionCheckService.applyUpdate()">{{ 'SHARED.Reload_Now' | translate }}</button>
      <button type="button" class="update-banner-dismiss" (click)="versionCheckService.dismissUpdate()" [attr.aria-label]="'SHARED.Dismiss_Update' | translate">×</button>
    </ng-container>
  </div>
  <ion-router-outlet (activate)="isAppDataLoaded = true" id="main-content">
    <app-header *ngIf="isAppDataLoaded === false && isAppVersionChecked"></app-header>
    <ion-content color="primary">
      <div class="content">
        <img *ngIf="brand !== 'erdman'" [src]="loaderImg" alt="Loader" />
        <div *ngIf="brand === 'erdman'" class="loadingio-spinner-double-ring-freyurszfti">
          <div class="ldio-2osr0q8yzqx">
            <div></div>
            <div></div>
            <div>
              <div></div>
            </div>
            <div>
              <div></div>
            </div>
          </div>
        </div>
        <p>GATHERING DATA</p>
      </div>
    </ion-content>
  </ion-router-outlet>
</ion-app>
